import React from 'react';
import { Toaster } from 'react-hot-toast';
import styles from './Toast.module.css';

/**
 * Toast Notification Component
 * Fully custom styled toast provider matching JACKOPOT design system
 * Uses react-hot-toast with custom styling
 */
const Toast = () => {
  return (
    <Toaster
      position="bottom-left"
      toastOptions={{
        duration: 4000,
        className: styles.toast,
        style: {
          background: 'var(--color-bg-card)',
          color: 'var(--color-text-primary)',
          border: '1px solid var(--color-border)',
          borderRadius: '8px',
          padding: '14px 18px',
          fontSize: '14px',
          fontFamily: 'var(--font-primary)',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.4)',
          maxWidth: '400px',
          minWidth: '300px',
          zIndex: 'var(--z-toast, 1080)',
        },
        success: {
          iconTheme: {
            primary: 'var(--color-success)',
            secondary: 'var(--color-bg-card)',
          },
          style: {
            borderLeft: '4px solid var(--color-success)',
            background: 'var(--color-bg-card)',
          },
          className: styles.toastSuccess,
        },
        error: {
          iconTheme: {
            primary: 'var(--color-error)',
            secondary: 'var(--color-bg-card)',
          },
          style: {
            borderLeft: '4px solid var(--color-error)',
            background: 'var(--color-bg-card)',
          },
          className: styles.toastError,
        },
        loading: {
          iconTheme: {
            primary: 'var(--color-text-secondary)',
            secondary: 'var(--color-bg-card)',
          },
          style: {
            borderLeft: '4px solid var(--color-text-secondary)',
            background: 'var(--color-bg-card)',
          },
          className: styles.toastLoading,
        },
      }}
      containerStyle={{
        bottom: '24px',
        left: '24px',
        zIndex: 'var(--z-toast, 1080)',
      }}
    />
  );
};

export default Toast;
